const helpToCreateNoPositionsLabel = (self: Record<string, any>): string => {
  const translations = [
    'noProjectsRequests',
    'noProjectsOngoing',
    'noProjectsCompleted',
    'noTodoInterviews',
    'noOngoingInterviews',
    'noCompletedInterviews',
    'noReportsTodo',
    'noReportsDrafts',
    'noReportsSent',
    'noReportsApproved',
  ];

  let noPositionLabel;

  translations.forEach((transl) => {
    if (
      transl.toLowerCase().includes(self.mode.toLowerCase()) &&
      transl.toLowerCase().includes(self.filter.toLowerCase())
    )
      noPositionLabel = self.$t(transl);
  });

  return noPositionLabel;
};

export default helpToCreateNoPositionsLabel;
